import { Box, GlobalStyles, Grid, Paper, Typography } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Form } from "../components/DataForm";
import { AppContext } from "../context";
import { useWindowDimensions } from "../hooks/useWindowDimensions";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const HomePage = () => {
  const {
    plan,
    getThemeAndPlans,
    logo,
    accountTheme,
    backgroundImage,
    theme,
    onlyBySeller,
    GetAndValidSeller,
  } = useContext(AppContext);
  let query = useQuery();
  const history = useHistory();
  const id = query.get("id");
  const sellerCode = query.get("sellerCode");
  const { width } = useWindowDimensions();
  const background = theme ? theme.palette.background.default : "#fff";

  useEffect(() => {
    if (!accountTheme) {
      getThemeAndSeller();
    }

  }, []);

  const getThemeAndSeller = async () => {
    const isBySeller = await getThemeAndPlans(id);
    if (isBySeller) {
      const res = await GetAndValidSeller(sellerCode);
      console.log(res);
      if (!res) {
        history.push("/errorsellercode");
      }
    }
  };

  return (
    <>
      {plan && (
        <Box
          sx={{
            maxHeight: "100vh",
            width: "80vw",
            maxWidth: "1500px",
            margin: "auto",
            paddingTop: "10px",
          }}
        >
          <GlobalStyles
            styles={{
              body: {
                backgroundColor: `${background}`,
                padding: "5px",
                maxHeight: "100vh",
              },
            }}
          />
          <Paper
            sx={{
              my: "auto",
              maxHeight: 650,
              backgroundColor: "background.default",
              boxShadow: 0,
            }}
          >
            <Grid container>
              <Grid
                item
                xl={8}
                md={8}
                sm={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  mb: width > 400 ? 0 : 2,
                  mr: width > 400 ? 1 : 0,
                }}
              >
                <Box
                  sx={{
                    pl: width > 400 ? 8 : 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    mb: width > 400 ? 1 : 2,
                  }}
                >
                  <Box>
                  <img src={logo} 
                    alt="" 
                    style={{ width: width > 400 ? theme.subAccountLogoWidth : '110px', marginBottom: '20px' }}
                  />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        color: "primary.main",
                        // fontWeight: 'bold',
                        fontSize: "1.8rem",
                        fontFamily: 'Montserrat'
                      }}
                    >
                      Falta Pouco!
                    </Typography>
                    <Typography
                      sx={{ color: "primary.main", fontSize: "1.2rem", fontFamily: 'Montserrat' }}
                    >
                      Precisamos de algumas informações para a <br /> emissão de
                      sua apólice.
                    </Typography>
                  </Box>
                  <Box sx={{ mt: 3 }}>
                    <Typography
                      sx={{ color: "secondary.main", fontSize: "1.8rem", fontFamily: 'Montserrat' }}
                    >
                      Plano Selecionado
                    </Typography>
                    <Typography
                      sx={{ color: "secondary.main", fontSize: "1.2rem", fontFamily: 'Montserrat' }}
                    >
                      <strong>{plan.plan_selected}:</strong> R$ {plan.price}
                    </Typography>
                    {plan.product_description && (
                      <Typography
                        sx={{ color: "secondary.main", fontSize: "1.2rem" }}
                      >
                        {plan.product_description}
                      </Typography>
                    )}
                  </Box>
                </Box>
                <Box sx={{ m: "0 auto", width: "100%" }}>
                  <Form />
                </Box>
              </Grid>
              {width > 1000 && (
                <Grid item>
                  <Box
                    sx={{
                      maxHeight: "100%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <img src={backgroundImage} width="350px" alt="" />
                  </Box>
                </Grid>
              )}
            </Grid>
          </Paper>
        </Box>
      )}
    </>
  );
};
